import React, { useRef, useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';

import { Divider, Grid, Paper, Typography, Zoom, Box } from '@material-ui/core';

import { useStylesAuth } from '../../styles/auth/style';
import TableGeneric from '../compartidos/abms/TableGeneric';
import BuscadorPad from './BuscadorPad';
import { finishSpinner } from '../../actions/ui/spinner';
import { TurnosOptions } from './TurnosOptions';
import { useTotem } from '../../hooks/useCases/useTotem';
import { ButtonGeneric, ButtonGroupGeneric } from '../atomic/atoms/Buttons';
import { useToggle } from '../../hooks/useToggle';
import { GenericModal } from '../atomic/organisms/GenericModal';
import { CustomDivider } from '../atomic/atoms/Divider';
import { GenericPrint } from '../atomic/organisms/GenericPrint';
import moment from 'moment';

function capitalizarPrimerLetraCadaPalabra(texto) {
    if (!!texto) {
        return texto.replace(/\b\w/g, function (l) {
            return l.toUpperCase();
        }).replace(/\B\w/g, function (l) {
            return l.toLowerCase();
        });
    }
}

const fotterStyle = {
    fontSize: "1.8em",
    fontWeight: "lighter",
    margin: "1.5em 0 0.2em"
}

const fotterMsg = "Por favor, dirigirse a la recepción del piso correspondiente a su consulta para registrar el presente si corresponde sino espere a ser llamado por el profesional en el piso de atención. Muchas gracias.";

const initConfirmModal = {
    open: false,
    confirm: false,
    value: null
}

const initConfirmOption = {
    open: false,
    mensaje: "",
    value: null
}

const initShow = {
    teclado: true,
    opciones: false,
    turnos: false,
    confirmModal: initConfirmModal,
    confirmOption: initConfirmOption
};

const Logo = () => {
    const classesAuth = useStylesAuth("light");
    return (
        <div
            style={{ margin: "auto" }}
            className={classesAuth.imageTotem}
        />
    )
}

export const TotemHome = () => {
    const dispatch = useDispatch();
    const totem = useTotem();
    const componentRef = useRef();

    const [afiliado, setAfiliado] = useState(null);
    const [show, setShow] = useState(initShow);

    const [restartTimer, setRestartTimer] = useToggle();

    useEffect(() => {
        if (afiliado !== null && afiliado?.id_afiliado) {
            totem.getById.turnosAfiliados(
                afiliado.id_afiliado,
                () => {
                    setShow({
                        ...show,
                        teclado: false,
                        opciones: true,
                    })
                }
            );
            setRestartTimer();
        }
    }, [dispatch, afiliado]);

    useEffect(() => { if (show.opciones) totem.get.opciones() }, [show.opciones]);

    useEffect(() => {
        let timer;
        if (!show.teclado) {
            timer = setTimeout(() => {
                setAfiliado(null);
                setShow(initShow);
            }, 25000);
        }

        return () => {
            clearTimeout(timer);
        };
    }, [restartTimer, show]);

    return (
        <div style={{ display: "grid", justifyContent: "center", alignItems: "center", height: "90vh", padding: "2.5em" }}>
            {show.teclado && (
                <Zoom
                    in={show.teclado}
                    {...(show.teclado ? { timeout: 500 } : {})}
                >
                    <Grid item xs={12} style={{ padding: "2em" }}>
                        <BuscadorPad
                            onChange={(value) => {
                                setAfiliado(value);
                                dispatch(finishSpinner());
                            }}
                            setValue={setAfiliado}
                            label="Beneficiaria/o"
                            endpoint={(inputValue) => `Afiliados/traerPorDNIoCarnet?parametro=${inputValue}`}
                        />
                    </Grid>
                </Zoom>
            )}

            {show.opciones && (
                <Zoom
                    in={show.opciones}
                    {...(show.opciones ? { timeout: 500 } : {})}
                >
                    <Grid container justify='center' component={Paper} elevation={5} style={{ padding: "1.5em" }}>
                        <Grid item xs={12} style={{ margin: "1em 0", textAlign: "center" }}>
                            <Typography variant='h4' style={{ fontSize: "2.5em", marginBottom: "0.5em" }}>
                                Seleccioná algunas de las siguientes opciones:
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <TurnosOptions
                                afiliado={afiliado}
                                setRestartTimer={() => { setRestartTimer() }}
                                setShowTurnos={() => setShow({
                                    ...show,
                                    opciones: false,
                                    turnos: true
                                })}
                                setConfirmOption={({ mensaje, value }) => {
                                    setShow({
                                        ...show,
                                        opciones: false,
                                        confirmOption: {
                                            open: true,
                                            mensaje, value
                                        }
                                    })
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} style={{ marginTop: "1.5em" }}>
                            <ButtonGeneric
                                size="large"
                                text="SALIR"
                                fullWidth
                                onClick={() => {
                                    setShow(initShow);
                                    totem.clean.opciones();
                                    setRestartTimer();
                                }}
                            />
                        </Grid>
                    </Grid>
                </Zoom>
            )}

            {show.turnos && (
                <Zoom
                    in={show.turnos}
                    {...(show.turnos ? { timeout: 500 } : {})}
                >
                    <Grid container justify='center' component={Paper} elevation={5} style={{ padding: "1.5em" }}>
                        <Grid item xs={12} style={{ margin: "1em 0", textAlign: "center" }}>
                            <Typography variant='h4' style={{ fontSize: "2.5em" }}>Bienvenido {`${capitalizarPrimerLetraCadaPalabra(afiliado?.apellido_y_nombre)} 😀`}</Typography>
                        </Grid>
                        <Grid item xs={12} style={{ margin: "3.5em" }}>
                            <TableGeneric
                                ref={componentRef}
                                data={totem.data.turnosAfiliados}
                                align="center"
                                withoutPagination
                                tituloSinResultado="No posee turnos para hoy"
                                rowStyle={{
                                    fontSize: "1.3em"
                                }}
                                colTitleStyle={{
                                    fontSize: "1.3em"
                                }}
                                tituloSinResultadoStyle={{
                                    fontSize: "1.2em"
                                }}
                                columns={[
                                    {
                                        id: "hora",
                                        label: "Hora",
                                    },
                                    {
                                        id: "nombreEfector",
                                        label: "Médico",
                                    },
                                    {
                                        id: "descripcionEspecialidad",
                                        label: "Especialidad",
                                    },
                                    {
                                        id: "piso",
                                        label: "Piso",
                                    },
                                    {
                                        id: "consultorio",
                                        label: "Consultorio",
                                    },
                                    {
                                        id: "recepcion",
                                        label: "Recepción",
                                    },
                                    // {
                                    //     label: "",
                                    //     customBody: (item) => (
                                    //         <ButtonGeneric
                                    //             type="button"
                                    //             text="CONFIRMAR"
                                    //             size="large"
                                    //             fullWidth
                                    //             variant="outlined"
                                    //             disabled={item.confirmado}
                                    //             onClick={() => {
                                    //                 setShow({
                                    //                     ...show,
                                    //                     confirmModal: {
                                    //                         ...show.confirmModal,
                                    //                         open: true,
                                    //                         value: item
                                    //                     }
                                    //                 })
                                    //             }}
                                    //         />
                                    //     )
                                    // },
                                    {
                                        label: "",
                                        customBody: (item) => <PrintModel {...{ item }} afiliado={afiliado} confirmaTurno={true} handleClose={() => {
                                            setShow({
                                                ...show,
                                                confirmModal: initConfirmModal
                                            });
                                            setRestartTimer();
                                        }}/>
                                    }
                                ]}
                            />
                        </Grid>
                        <DividerLine />
                        <Grid item xs={10} style={{ margin: "1em 0", textAlign: "center" }}>
                            <Typography variant='h4' style={{ ...fotterStyle }}>{fotterMsg}</Typography>
                            <Logo />
                        </Grid>
                        <DividerLine />
                        <Grid item xs={12} style={{ marginTop: "0.5em" }}>
                            <ButtonGeneric
                                sx={{ borderRadius: 0 }}
                                fullWidth
                                type="button"
                                text="VOLVER"
                                onClick={() => {
                                    setShow({
                                        ...show,
                                        turnos: false,
                                        opciones: true
                                    });
                                    setRestartTimer();
                                }}
                            />
                        </Grid>
                    </Grid>
                </Zoom>
            )}

            {show.confirmModal.open && (
                <GenericModal
                    open={show.confirmModal.open}
                    title={`Confirmar Turno - ${show.confirmModal.value.nombreEfector}`}
                    handleClose={() => {
                        setShow({
                            ...show,
                            confirmModal: initConfirmModal
                        });
                        setRestartTimer();
                    }}
                    textButton="Aceptar"
                    handleButton={() => {
                        const item = show.confirmModal.value;
                        totem.insert.confirmTurnoAfiliado(
                            { idAgenda: item.id, idAfiliado: afiliado.id_afiliado, piso: item.piso }, { id: item.id, confirmado: true },
                            () => setShow({
                                ...show,
                                confirmModal: initConfirmModal
                            })
                        )
                        setRestartTimer();
                    }}
                    fullWidthButtons
                >
                    <div style={{ textAlign: "center", margin: "0.5em" }}>
                        <Typography variant='button' style={{ color: "#555", fontSize: "1.5em" }}>
                            {`Desea confirmar el turno de las ${show.confirmModal.value.hora}hs del consultorio ${show.confirmModal.value.consultorio}`}
                        </Typography>
                    </div>
                </GenericModal>
            )}

            {show.confirmOption.open && (
                <Zoom
                    in={show.confirmOption.open}
                    {...(show.confirmOption.open ? { timeout: 500 } : {})}
                >
                    <Grid container justify='center'>
                        <Grid item xs={11} component={Paper} elevation={5}>
                            <Grid container justify='center' style={{ marginBottom: "1em" }}>
                                <Grid item xs={12}>
                                    <Logo />
                                    <CustomDivider />
                                    <Typography variant='h4' style={{ fontSize: "1.8em", margin: "0.5em 2em 1em 2em", textAlign: "center" }}>
                                        {show.confirmOption?.mensaje}
                                    </Typography>
                                    <Box align="center" style={{ margin: "1em" }}>
                                        <PrintModel option={show.confirmOption?.value} mensaje={show.confirmOption?.mensaje} afiliado={afiliado} />
                                    </Box>
                                    <CustomDivider />
                                </Grid>
                            </Grid>
                            <ButtonGroupGeneric
                                buttonList={[
                                    {
                                        style: { borderRadius: 0 },
                                        size: "large",
                                        type: "button",
                                        text: "SALIR",
                                        fullWidth: true,
                                        color: "secondary",
                                        onClick: () => {
                                            setShow(initShow);
                                            totem.clean.opciones();
                                            setRestartTimer();
                                        }
                                    },
                                    {
                                        style: { borderRadius: 0 },
                                        size: "large",
                                        type: "button",
                                        text: "VOLVER",
                                        fullWidth: true,
                                        onClick: () => {
                                            setShow({
                                                ...show,
                                                opciones: true,
                                                confirmOption: initConfirmOption
                                            });
                                            setRestartTimer();
                                        }
                                    },
                                ]}
                            />
                        </Grid>
                    </Grid>
                </Zoom>
            )}
        </div>
    )
}

const DividerLine = () => (
    <Grid item xs={12}>
        <Divider variant='middle' />
    </Grid>
);

export const PrintModel = ({ item, option, mensaje, afiliado, confirmaTurno, handleClose }) => {
    const typographyProps = {
        variant: 'caption',
        style: {
            fontSize: "1.3em",
            fontWeight: "bolder",
        }
    };

    return (
        <GenericPrint
            label='Imprimir Turno'
            confirmaTurno={confirmaTurno}
            item={item}
            afiliado={afiliado}
            handleClose={handleClose}
            listItems={[
                {
                    children: (
                        <Logo />
                    )
                },
                {
                    children: (
                        <div style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center" }}>
                            <Typography {...typographyProps}>{afiliado?.carnet}</Typography>
                          
                        </div>
                    )
                },
                {
                    children: (
                        <div style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center" }}>
                            <Typography {...typographyProps}>{`${moment().format("DD/MM/YYYY")}`}</Typography>
                            <Typography {...typographyProps}>{`${moment().format("hh:mm")}hs`}</Typography>
                        </div>
                    )
                },
                ...(option ? [
                    {
                        children: (
                            <div style={{ textAlign: "center" }}>
                                <Typography {...{ ...typographyProps, fontSize: "1.5em" }}>{`Opcion seleccionada: ${option?.descripcion}`}</Typography>
                            </div>
                        ),
                    },
                    {
                        children: (
                            <div style={{ textAlign: "center" }}>
                                <Typography {...{ ...typographyProps, fontSize: "1.5em" }}>{`Dirigirse: ${option?.recepcion?.descripcion}`}</Typography>
                            </div>
                        ),
                    },
                    {
                        children: (
                            <div style={{ width: "80%", margin: "3em", fontSize: "1.2em" }}>
                                <Typography  {...typographyProps}>{mensaje}</Typography>
                            </div>
                        )
                    }
                ] : [
                    {
                        children: (
                            <div style={{ textAlign: "center" }}>
                                <Typography {...typographyProps}>{`Hora: ${item?.hora}hs`}</Typography>
                            </div>
                        )
                    },
                    {
                        children: (
                            <div style={{ textAlign: "center" }}>
                                <Typography  {...typographyProps}>{`Médico: ${item?.nombreEfector}`}</Typography>
                            </div>
                        )
                    },
                    {
                        children: (
                            <div style={{ textAlign: "center" }}>
                                <Typography  {...typographyProps}>{`Especialidad: ${item?.descripcionEspecialidad}`}</Typography>
                            </div>
                        )
                    },
                    // {
                    //     children: (
                    //         <div style={{ textAlign: "center" }}>
                    //             <Typography  {...typographyProps}>{`Piso: ${item?.piso}`}</Typography>
                    //         </div>
                    //     )
                    // },
                    {
                        children: (
                            <div style={{ textAlign: "center" }}>
                                {item?.adeuda
                                    ? <Typography  {...typographyProps}>{`Por favor, dirigirse a la recepción: ${item?.recepcion} y aguarde a ser atendido`}</Typography>
                                    : <Typography  {...typographyProps}>{`Por favor, dirigirse al piso: ${item?.piso} y aguarde a ser llamado por el profesional`}</Typography>
                                }                                
                            </div>
                        )
                    }
                    // {
                    //     children: (
                    //         <div style={{ textAlign: "center" }}>
                    //             <Typography  {...typographyProps}>{`Consultorio: ${item?.consultorio}`}</Typography>
                    //         </div>
                    //     )
                    // },
                   
                ]),
            ]}
        />
    );
};